import React, { useContext } from 'react';
import { ReactComponent as CrossIcon } from 'assets/icon/x-circle.svg';
import PrimaryDarkButton from 'components/common/buttons/primary-dark-btn';
import DarkButton from 'components/common/buttons/dark-btn';
import { useAppDispatch, useAppSelector } from 'hooks/useAppDispatchSelector';
import { initModal, formatText, camelCase, capitalize, appointmentStatusEnum } from 'helpers/utils';
import { setModal } from 'store/features/modelSlice';
import { AppContext } from 'context/app-context';
import moment from 'moment';
import { changeWorkshopAppointmentStatus } from 'store/features/workshopAppointmentsSlice';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

const ChangeWorkshopAppointmentStatus: React.FC = () => {
  const dispatch = useAppDispatch();
  const { workshopAppointmentDetails } = useAppSelector(state => state.workShopAppointment);
  const {
    modal: {
      content: { callBackFun },
    },
  } = useAppSelector(state => state.modal);
  const { setLoader } = useContext(AppContext);

  const { t } = useTranslation();

  const handleSubmit = async () => {
    try {
      setLoader(true);
      await dispatch(
        changeWorkshopAppointmentStatus({
          request: {
            appointment_id: workshopAppointmentDetails?._id || '',
            status: appointmentStatusEnum?.IN_PROGRESS,
          },
        }),
      )
        .then(() => {
          toast.success(t('workshopAppointment.changeStatus.successChangeStatusToastMessage '));
          callBackFun && callBackFun();
          dispatch(setModal(initModal));
          setLoader(false);
        })
        .catch(() => {
          setLoader(false);
        });
    } catch (error) {
      setLoader(false);
    }
  };
  return (
    <div className="flex flex-wrap max-w-[460px] w-[460px] gap-y-3 overflow-hidden">
      <div className="flex items-center w-full">
        <div className="flex items-center flex-1">
          <label className="pl-2 text-xl font-semibold text-black2">
            {t('workshopAppointment.changeStatus.changeStatusTitle')}
          </label>
        </div>
        <div
          className="flex items-center justify-center cursor-pointer"
          onClick={() => dispatch(setModal(initModal))}
        >
          <CrossIcon height={32} width={32} />
        </div>
      </div>
      <span className="font-medium mx-2">
        {t('workshopAppointment.changeStatus.changeStatusSubTitle')}{' '}
        <span className="font-bold text-base">
          {capitalize(camelCase(formatText(workshopAppointmentDetails?.status, ' ')))}
        </span>{' '}
        {t('workshopAppointment.changeStatus.to')}
        <span className="font-bold text-base">
          {t('workshopAppointment.changeStatus.inProgress')}
        </span>
        ?
      </span>
      <div className="flex flex-wrap w-full overflow-y-auto max-h-[calc(100vh-250px)] gap-y-1 bg-grey4 rounded-4 p-4">
        <div className="flex items-center w-full gap-x-2">
          <label className="font-medium text-sm">{t('workshopAppointment.steps.time')}:</label>
          <label className="text-sm">
            {workshopAppointmentDetails?.slot
              ? moment(
                  `${workshopAppointmentDetails?.slot.date} ${workshopAppointmentDetails?.slot.time}`,
                  'YYYY-MM-DD HH:mm',
                ).format('MMM DD, YYYY [at] HH:mm')
              : '-'}
          </label>
        </div>
        <div className="flex items-center w-full gap-x-2">
          <label className="font-medium text-sm">
            {t('workshopAppointment.tableHeaders.service_type')}:
          </label>
          <label className="text-sm">
            {workshopAppointmentDetails?.other_service_type
              ? workshopAppointmentDetails?.other_service_type
              : workshopAppointmentDetails?.alert_details
              ? `${workshopAppointmentDetails?.alert_details?.alert_ref} ${workshopAppointmentDetails?.alert_details?.title}`
              : '-'}
          </label>
        </div>
      </div>
      <div className="flex items-center justify-center w-full gap-x-4 mt-4">
        <PrimaryDarkButton
          label={t('payments.addPayment.confirm')}
          onClick={() => handleSubmit()}
          width="w-1/2"
        />
        <DarkButton
          label={t('CANCEL')}
          width="w-1/2"
          onClick={() => dispatch(setModal(initModal))}
        />
      </div>
    </div>
  );
};

export default ChangeWorkshopAppointmentStatus;
